import { IconWrapper } from '../runtime';
export default IconWrapper('extract-text', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M14.25 7.99976V3.24976C14.25 2.42133 13.5784 1.74976 12.75 1.74976H3.25C2.42157 1.74976 1.75 2.42133 1.75 3.24976V12.7498C1.75 13.5782 2.42157 14.2498 3.25 14.2498H6",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M10 13.2498H14.5M14.5 13.2498L13 11.9998M14.5 13.2498L13 14.4998",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M5.75 5.99976H10.25M8 5.99976V10.2498",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});